module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-7-526d167d2f8fcccad67909d1a46effea.webp";